import { Box, CardActionArea, CardHeader } from '@mui/material';
import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';

interface DeviceCardActionAreaProps {
  expanded: boolean;
  header: string;
  headerIcon?: React.ElementType;
  hasHeaderAction?: boolean;
  handleExpandClick: () => void;
}

const DeviceCardActionArea = ({
  handleExpandClick,
  expanded,
  header,
  headerIcon: HeaderIcon,
  hasHeaderAction = false,
}: DeviceCardActionAreaProps) => {
  const { t } = useTranslation();

  return (
    <CardActionArea onClick={handleExpandClick} aria-expanded={expanded} aria-label={t('aria-label.show-more')} sx={{ position: 'relative' }}>
      <CardHeader
        avatar={
          HeaderIcon ? (
            <Box
              component={HeaderIcon}
              aria-hidden
              sx={{
                width: 24,
                height: 24,
                display: 'block',
                color: 'primary.main',
              }}
            />
          ) : null
        }
        title={header}
        sx={{
          minHeight: 56,
          px: 2,
          py: 1,
          pr: hasHeaderAction ? 15 : 6,
          '& .MuiCardHeader-avatar': {
            mr: 1.5,
          },
          '& .MuiCardHeader-content': {
            minWidth: 0,
          },
          '& .MuiCardHeader-title': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },
        }}
      />
      <ExpandMoreIcon
        fontSize="large"
        color={'primary'}
        sx={{
          position: 'absolute',
          right: 20,
          top: '50%',
          transform: expanded ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)',
          transition: 'transform 0.5s ease-in-out',
        }}
      />
    </CardActionArea>
  );
};

export default DeviceCardActionArea;
